export const ru = {
    from: 'От',
    to: 'Дo',
    reset: 'Сбросить',
    apply: 'Применить',
};
